import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {AssessmentGroup} from '../../rfi-individual-results-modal.types';
import {RfiMetricValuePipe} from '../../rfi-metric-value.pipe';

@Component({
  selector: 'app-rfi-assessment-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, RfiMetricValuePipe],
  host: {class: 'card flex flex-col gap-2 p-4'},
  templateUrl: './rfi-assessment-group.component.html',
})
export class RfiAssessmentGroupComponent {
  readonly group = input.required<AssessmentGroup>();
}
